/**
 * Utility functions for handling grade-related operations
 */

export const getGradeLevel = async (user) => {
  try {
    // If user has a grade property, use that
    if (user && user.grade) {
      return user.grade;
    }
    
    // If user is not available, try to get from localStorage
    const storedUser = JSON.parse(localStorage.getItem('user') || '{}');
    if (storedUser && storedUser.grade) {
      return storedUser.grade;
    }
    
    // Default to grade 1 if no grade is found
    return 1;
  } catch (error) {
    console.error('Error getting grade level:', error);
    return 1; // Default to grade 1 on error
  }
};

/**
 * Get the appropriate word list path based on grade and year
 * @param {number} grade - The user's grade level
 * @param {number} year - The current year
 * @param {string} type - Type of word list ('hyphen-space', 'uppercase', 'default')
 * @returns {string} - The path to the word list
 */
export const getWordListPath = (grade, year, type = 'default') => {
  const gradeLevel = grade >= 1 && grade <= 5 ? 'Elementary' : 'Senior';
  
  switch (type) {
    case 'hyphen-space':
      return `../practice/resources/SpellBowl/Grade${grade}/${year}/premium300/${gradeLevel} Word List ${year} with hyphens and spaces.json`;
    case 'uppercase':
      return `../practice/resources/SpellBowl/Grade${grade}/${year}/premium300/${gradeLevel} Word List ${year} with upper cases.json`;
    default:
      return `../practice/resources/SpellBowl/Grade${grade}/${year}/premium300/${gradeLevel} Word List ${year}.json`;
  }
};
